/* GENERATED by style-dictionary.config.mjs from tokens/*.json — do not edit. */

export const baseTokens = {
  "blur": {
    "regular": "24px",
    "thick": "32px"
  },
  "brand": {
    "oliveLeaf": "#00320a",
    "blackForest": "#0f1f12",
    "cornsilk": "#fefae0",
    "sunlitClay": "#dda15e",
    "copperwood": "#bc6c25",
    "gold": "#d2b956"
  },
  "density": {
    "0": "0px",
    "minus2": "-8px"
  },
  "elevation": {
    "level0": "none",
    "level1": "0 1px 2px rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.02)",
    "level2": "0 1px 2px rgba(0, 0, 0, 0.04), 0 2px 8px rgba(0, 0, 0, 0.03)",
    "level3": "0 2px 6px rgba(0, 0, 0, 0.06), 0 12px 32px rgba(0, 0, 0, 0.1)",
    "level4": "0 4px 10px rgba(0, 0, 0, 0.08), 0 20px 48px rgba(0, 0, 0, 0.14)",
    "level5": "0 6px 14px rgba(0, 0, 0, 0.1), 0 28px 64px rgba(0, 0, 0, 0.18)"
  },
  "focusRing": {
    "width": "3px",
    "offset": "2px"
  },
  "font": {
    "family": {
      "base": "'Vazirmatn Variable', Vazirmatn, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Tahoma, sans-serif",
      "mono": "ui-monospace, monospace"
    },
    "size": {
      "2xs": "0.75rem",
      "xs": "0.8125rem",
      "sm": "0.875rem",
      "md": "1rem",
      "lg": "1.05rem",
      "xl": "1.35rem",
      "2xl": "1.7rem",
      "3xl": "2.15rem"
    },
    "weight": {
      "regular": 400,
      "medium": 600,
      "semibold": 650,
      "bold": 700,
      "heavy": 800
    },
    "lineHeight": {
      "base": 1.5,
      "tight": 1.18,
      "relaxed": 1.7
    },
    "role": {
      "eyebrow": "0.8125rem",
      "pageTitlePhone": "1.5rem",
      "sheetTitle": "1.5rem",
      "termsRow": "0.8125rem",
      "stat": "2.75rem"
    },
    "typescale": {
      "displaySmall": "2.25rem",
      "headlineLarge": "2rem",
      "headlineSmall": "1.5rem",
      "titleLarge": "1.375rem",
      "titleMedium": "1rem",
      "titleSmall": "0.875rem",
      "bodyLarge": "1rem",
      "bodyMedium": "0.875rem",
      "bodySmall": "0.8125rem",
      "labelLarge": "0.875rem",
      "labelMedium": "0.75rem",
      "labelSmall": "0.75rem"
    }
  },
  "layout": {
    "pageInline": {
      "phone": "16px",
      "wide": "24px"
    },
    "pageBlock": {
      "phone": "16px",
      "wide": "24px"
    },
    "sectionGap": {
      "phone": "24px",
      "wide": "32px"
    },
    "cardGap": {
      "phone": "12px",
      "wide": "16px"
    },
    "cardPadding": {
      "phone": "16px",
      "wide": "24px"
    },
    "stackGap": {
      "phone": "12px",
      "wide": "12px"
    },
    "itemGap": {
      "phone": "8px",
      "wide": "8px"
    },
    "listRowPadding": {
      "phone": "12px",
      "wide": "16px"
    }
  },
  "motion": {
    "duration": {
      "press": "120ms",
      "fast": "180ms",
      "base": "240ms",
      "page": "300ms",
      "short1": "50ms",
      "short2": "100ms",
      "short3": "150ms",
      "short4": "200ms",
      "medium1": "250ms",
      "medium2": "300ms",
      "medium3": "350ms",
      "medium4": "400ms",
      "long1": "450ms",
      "long2": "500ms",
      "long3": "550ms",
      "long4": "600ms"
    },
    "easing": {
      "standard": [
        0.2,
        0,
        0,
        1
      ],
      "standardDecelerate": [
        0,
        0,
        0,
        1
      ],
      "standardAccelerate": [
        0.3,
        0,
        1,
        1
      ],
      "emphasizedDecelerate": [
        0.05,
        0.7,
        0.1,
        1
      ],
      "emphasizedAccelerate": [
        0.3,
        0,
        0.8,
        0.15
      ],
      "legacy": [
        0.2,
        0.8,
        0.2,
        1
      ]
    }
  },
  "radius": {
    "xs": "0.65rem",
    "sm": "0.8rem",
    "md": "0.9rem",
    "lg": "1rem",
    "xl": "1.5rem",
    "2xl": "1.75rem",
    "3xl": "2rem",
    "pill": "999px"
  },
  "shape": {
    "none": "0",
    "extraSmall": "4px",
    "small": "8px",
    "medium": "12px",
    "large": "16px",
    "largeIncreased": "20px",
    "extraLarge": "28px",
    "extraLargeIncreased": "32px",
    "full": "9999px"
  },
  "size": {
    "touchTarget": "48px",
    "sidebar": "15rem",
    "contentMax": "88rem"
  },
  "space": {
    "0": "0",
    "1": "0.25rem",
    "2": "0.5rem",
    "3": "0.75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "8": "2rem",
    "10": "2.5rem",
    "12": "3rem",
    "16": "4rem",
    "05": "0.125rem"
  },
  "state": {
    "layer": {
      "hover": 0.08,
      "focus": 0.1,
      "pressed": 0.1,
      "dragged": 0.16
    },
    "disabled": {
      "container": 0.12,
      "content": 0.38
    }
  },
  "window": {
    "compactMax": "599px",
    "mediumMin": "600px",
    "mediumMax": "839px",
    "expandedMin": "840px",
    "expandedMax": "1199px",
    "largeMin": "1200px",
    "xlargeMin": "1600px"
  }
} as const;

export const lightColors = {
  "bg": "#f2f2f7",
  "surface": "#ffffff",
  "surfaceRaised": "#ffffff",
  "surfaceSunken": "#efeff4",
  "surface1": "#ffffff",
  "surface2": "#efeff4",
  "surface3": "#e5e5ea",
  "fieldBg": "#f2f2f7",
  "border": "#3c3c432e",
  "borderStrong": "#8e8e93",
  "text": "#1d1d1f",
  "textMuted": "#666669",
  "onSurfaceVariant": "#666669",
  "primary": "#1e6b47",
  "primaryHover": "#185a3c",
  "primarySoft": "#1e6b4714",
  "onPrimary": "#ffffff",
  "link": "#1b6a45",
  "focus": "#2e8b5f",
  "emphasis": "#1e6b47",
  "cardFrom": "#00320a",
  "cardTo": "#0a4419",
  "cardGlow": "#11521f",
  "onCard": "#fefae0",
  "success": "#386a20",
  "successBg": "#d7e8c8",
  "successText": "#1b4332",
  "warning": "#bc6c25",
  "warningBg": "#dda15e2b",
  "warningText": "#8a4b14",
  "danger": "#b3261e",
  "dangerBg": "#b3261e1a",
  "dangerText": "#9c211a",
  "info": "#006874",
  "infoBg": "#cde8ec",
  "infoText": "#004a55",
  "neutralBg": "#e5e5ea",
  "neutralText": "#666669",
  "gift": "#bc6c25",
  "giftBg": "#bc6c251c",
  "glassBg": "#ffffffdb",
  "glassBgStrong": "#fffffff0",
  "glassBorder": "#3c3c431f",
  "glassHighlight": "#ffffffeb",
  "glassShade": "#0000000d",
  "scrim": "#00000066",
  "navActiveBg": "#e5e5ea",
  "navActiveInk": "#1d1d1f",
  "navActiveIcon": "#1e6b47",
  "primaryContainer": "#dcefe4",
  "onPrimaryContainer": "#123a27",
  "secondary": "#636366",
  "onSecondary": "#ffffff",
  "secondaryContainer": "#d1d1d6",
  "onSecondaryContainer": "#1c1c1e",
  "tertiary": "#39656b",
  "onTertiary": "#ffffff",
  "tertiaryContainer": "#bcebf2",
  "onTertiaryContainer": "#001f23",
  "error": "#b3261e",
  "onError": "#fefae0",
  "errorContainer": "#f9dedc",
  "onErrorContainer": "#410e0b",
  "surfaceDim": "#d1d1d6",
  "surfaceBright": "#ffffff",
  "surfaceContainerLowest": "#ffffff",
  "surfaceContainerLow": "#f9f9fb",
  "surfaceContainer": "#efeff4",
  "surfaceContainerHigh": "#e5e5ea",
  "surfaceContainerHighest": "#d1d1d6",
  "onSurface": "#1d1d1f",
  "outline": "#8a8a8f",
  "outlineVariant": "#d8d8dc",
  "inverseSurface": "#2c2c2e",
  "inverseOnSurface": "#f2f2f7",
  "inversePrimary": "#5bbf8e",
  "shadow": "#000000",
  "panel": "#ffffff",
  "panelBorder": "#ffffff00",
  "highlightFrom": "#1e6b47",
  "highlightTo": "#2a8458",
  "onHighlight": "#ffffff",
  "bgGlow": "#00000000"
} as const;

export const darkColors = {
  "bg": "#1c1c1e",
  "surface": "#2c2c2e",
  "surfaceRaised": "#323234",
  "surfaceSunken": "#323234",
  "surface1": "#2c2c2e",
  "surface2": "#323234",
  "surface3": "#3a3a3c",
  "fieldBg": "#323234",
  "border": "#5454588c",
  "borderStrong": "#ffffff5c",
  "text": "#f2f2f7",
  "textMuted": "#a3a3a9",
  "onSurfaceVariant": "#a3a3a9",
  "primary": "#5bbf8e",
  "primaryHover": "#6fcb9d",
  "primarySoft": "#5bbf8e24",
  "onPrimary": "#0b1a12",
  "link": "#79d3a6",
  "focus": "#5bbf8e",
  "emphasis": "#5bbf8e",
  "cardFrom": "#00320a",
  "cardTo": "#0a4419",
  "cardGlow": "#11521f",
  "onCard": "#fefae0",
  "success": "#9ccc65",
  "successBg": "#388e3c3d",
  "successText": "#c8e6c9",
  "warning": "#dda15e",
  "warningBg": "#dda15e26",
  "warningText": "#dda15e",
  "danger": "#f28b82",
  "dangerBg": "#f28b8224",
  "dangerText": "#f7b1aa",
  "info": "#4dd0e1",
  "infoBg": "#0097a738",
  "infoText": "#b2ebf2",
  "neutralBg": "#3a3a3c",
  "neutralText": "#a3a3a9",
  "gift": "#dda15e",
  "giftBg": "#bc6c252e",
  "glassBg": "#2c2c2edb",
  "glassBgStrong": "#2c2c2ef0",
  "glassBorder": "#54545873",
  "glassHighlight": "#ffffff0a",
  "glassShade": "#0000004d",
  "scrim": "#00000080",
  "navActiveBg": "#3a3a3c",
  "navActiveInk": "#f2f2f7",
  "navActiveIcon": "#5bbf8e",
  "primaryContainer": "#1d3f2e",
  "onPrimaryContainer": "#bfe6d0",
  "secondary": "#aeaeb2",
  "onSecondary": "#1c1c1e",
  "secondaryContainer": "#48484a",
  "onSecondaryContainer": "#f2f2f7",
  "tertiary": "#a1cfd5",
  "onTertiary": "#00363c",
  "tertiaryContainer": "#1f4d53",
  "onTertiaryContainer": "#bcebf2",
  "error": "#f28b82",
  "onError": "#601410",
  "errorContainer": "#7a2924",
  "onErrorContainer": "#f9dedc",
  "surfaceDim": "#161618",
  "surfaceBright": "#48484a",
  "surfaceContainerLowest": "#161618",
  "surfaceContainerLow": "#2c2c2e",
  "surfaceContainer": "#323234",
  "surfaceContainerHigh": "#3a3a3c",
  "surfaceContainerHighest": "#48484a",
  "onSurface": "#f2f2f7",
  "outline": "#8e8e93",
  "outlineVariant": "#5454588c",
  "inverseSurface": "#f2f2f7",
  "inverseOnSurface": "#2c2c2e",
  "inversePrimary": "#1e6b47",
  "shadow": "#000000",
  "panel": "#2c2c2edb",
  "panelBorder": "#54545852",
  "highlightFrom": "#1d4a35",
  "highlightTo": "#25603f",
  "onHighlight": "#e3f2ea",
  "bgGlow": "#00000000"
} as const;

export const lightShadows = {
  "elev1": "0 1px 2px rgba(0, 0, 0, 0.04), 0 1px 1px rgba(0, 0, 0, 0.02)",
  "elev2": "0 1px 2px rgba(0, 0, 0, 0.04), 0 2px 8px rgba(0, 0, 0, 0.03)",
  "elev3": "0 2px 6px rgba(0, 0, 0, 0.06), 0 12px 32px rgba(0, 0, 0, 0.1)",
  "elev4": "0 4px 10px rgba(0, 0, 0, 0.08), 0 20px 48px rgba(0, 0, 0, 0.14)",
  "elev5": "0 6px 14px rgba(0, 0, 0, 0.1), 0 28px 64px rgba(0, 0, 0, 0.18)"
} as const;

export const darkShadows = {
  "elev1": "0 1px 2px rgba(0, 0, 0, 0.2), 0 1px 1px rgba(0, 0, 0, 0.1)",
  "elev2": "0 1px 2px rgba(0, 0, 0, 0.2), 0 2px 6px rgba(0, 0, 0, 0.12)",
  "elev3": "0 2px 6px rgba(0, 0, 0, 0.26), 0 12px 28px rgba(0, 0, 0, 0.32)",
  "elev4": "0 4px 10px rgba(0, 0, 0, 0.3), 0 18px 40px rgba(0, 0, 0, 0.38)",
  "elev5": "0 6px 14px rgba(0, 0, 0, 0.32), 0 24px 56px rgba(0, 0, 0, 0.44)"
} as const;

export type ColorToken = keyof typeof lightColors;
